import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
//import { HeaderHelperOptions } from '@base-interfaces/header-helper';

@Injectable({
  providedIn: 'root'
})
export class MainSidebarService {

  //iconSet: Subject<HeaderHelperOptions> = new Subject<HeaderHelperOptions>();
  panelOpen: Subject<any> = new Subject<any>();
  toggleSidebarCollapsed: Subject<any> = new Subject<any>();
  //titleSet: Subject<any> = new Subject<any>();
  ///displayHeader: Subject<any> = new Subject<any>();

  constructor() { }


  /**
   * Notify to side panel that should be closed
   */
  panelCollapsed() {
    this.toggleSidebarCollapsed.next();
  }



}
